import React from 'react';

import { BlockaidLogo } from '@infinex-private/connect-web-shared/assets';
import { ChevronRightIcon, InfoIcon } from '@infinex/ui-icons';
import { cn } from '@infinex/ui-styles';
import { Text } from '@infinex/ui/components';

interface MaliciousTransactionCardProps {
  onClick?: () => void;
  className?: string;
}

export function MaliciousTransactionCard({
  onClick,
  className,
}: MaliciousTransactionCardProps) {
  return (
    <div
      className={cn(
        'bg-fillCritical flex items-center gap-3 rounded-2xl px-2 py-2',
        onClick &&
          'hover:bg-fillCriticalHover cursor-pointer transition-opacity',
        className
      )}
      onClick={onClick}
    >
      <InfoIcon fill="critical" className="size-5" />

      <div className="flex-1">
        <Text className="text-emphasis text-sm font-semibold">
          Malicious transaction detected
        </Text>
        <div className="flex items-center gap-1">
          <Text className="text-secondary text-sm font-semibold">
            Powered by
          </Text>
          <img
            src={BlockaidLogo}
            alt="Blockaid"
            className="h-3 w-auto"
            style={{
              filter:
                'brightness(0) saturate(100%) invert(60%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%)',
            }}
          />
        </div>
      </div>

      {onClick && <ChevronRightIcon className="fill-tertiary size-4" />}
    </div>
  );
}
